module.exports = __webpack_public_path__ + "img/HowItWork_item_02.7957c874.png";